import Tools from '../tools/tools.js'

let currentPageName = null
let currentRefPageName = null
/* 获得城市 */
const getCurrentCityId = function () {
  if (localStorage.USER_CITY) {
    let city = JSON.parse(localStorage.USER_CITY)
    if (city) {
      return city.cityId
    }
  }
  return '0'
}
/**
* 获得当前用户ID
*/
const getCurrentUserId = function () {
  if (localStorage.USER_INFO) {
    let user = JSON.parse(localStorage.USER_INFO)
    if (user) {
      return user.platformAgentID
    }
  }
  return '0'
}
/* 创建默认模型 */
const createDefaultModel = function () {
  var defa = {
    platform: '',
    app: '0',
    page: '',
    refpage: '',
    pvareaid: '',
    city: '',
    actid: '',
    userid: '0'
  }
  if (navigator.userAgent.indexOf('Android') > 0) {
    defa.platform = '1'
  } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    defa.platform = '2'
  } else {
    defa.platform = '0'
  }
  defa.pvareaid = Tools.getQueryString('pvareaid')
  if (!defa.pvareaid) {
    defa.pvareaid = '2338149'
  }
  defa.city = getCurrentCityId()
  defa.userid = getCurrentUserId()
  return defa
}
/*
格式化path
*/
const formatPath = function (path) {
  const pathPre = 'social_b'
  if (!path) {
    console.log('error_path')
    return pathPre
  }
  const array = path.split('/')
  return pathPre + array.join('_')
}
/**
 * 构建当前页面名称
 */
const buildRoutePageName = function (router) {
  if (!router.params || Object.keys(router.params).length > 0) {
    return router.name
  } else {
    return formatPath(router.path)
  }
}
/**
 * 处理特出页面参数问题
 * @param {*vue路由} router
 * @param {*} model
 */
const handleSpecialPageParams = function (router, model) {
  if (Object.keys(router.params).length >= 0) {
    if (router.name === 'ActivityDetail') {
      model.actid = router.params.platformActivityId || 0
    }
  }
}
/**
* 统计问题
*/
const stat = {
  /**
  * 加载埋点
  */
  load: function (model) {
   console.log(model);
  },
  /**
  * 点击埋点
  */
  click: function (btnName, params, model) {
    model.clickname = btnName
    if (params) {
      for (let item in params) {
        let value = params[item]
        if (value) {
          model[item] = value
        }
      }
    }
  },
  /* 路由信息 */
  routerAfterEach: function (to, from) {
    const model = createDefaultModel()
    model.page = buildRoutePageName(to)
    model.refpage = buildRoutePageName(from)
    handleSpecialPageParams(to, model)
    currentPageName = model.page
    currentRefPageName = model.refpage
    stat.load(model)
  },
  /**
   * stat 指令
   */
  statDirective: {
    bind: function (el, binding, vnode) {
      let name = binding.value.name
      if (!name) {
        console.error('v-stat directive need name')
        name = 'default_btn'
      }
      const params = binding.value
      delete params.name
      let model = createDefaultModel()
      model.page = currentPageName
      model.refpage = currentRefPageName
      el.addEventListener('click', function () {
        stat.click(name, params, model)
      })
    }
  },
  /**
  * vue安装指令
  */
  install: function (Vue) {
    Vue.directive('stat', stat.statDirective)
  }
}

export default stat



// WEBPACK FOOTER //
// ./src/plugins/plantStat.js